// extracted by mini-css-extract-plugin
module.exports = {"avatar":"TrainerAvatar_avatar__QWQEi","overlayingCover":"TrainerAvatar_overlayingCover__1JEeD"};